export const whatsappId = 'whatsapp'
export const helpUsToImproveId = 'helpUsToImprove'
export const whatsappUrl = process.env.REACT_APP_WHATSAPP
